/* Park Friends first-party click tracking (2026-10-01, early access night).

   What it does: one session id per browser (localStorage, random, nothing personal), delegated
   listeners on the real markup, small batches sent with sendBeacon to the store's own worker
   (pf-sms-proxy, the lock page SMS proxy, same account). Counted by LA day: sessions by device
   and first touch, page views by type, the clicks the owner asked about, JS errors, and the
   funnel session, product view, add to cart, checkout click.

   What it never does: no third party, no cookies, no email, phone, name, order or customer id,
   no IP (the worker does not store one), nothing on the paint path (defer, idle flush). Opt out:
   localStorage.pf_track = 'off', a Global Privacy Control signal, the theme editor, or a theme
   preview. Loaded from layout/theme.liquid after the pf scripts. The lock page does not load it.

   Event names and values (the worker keeps only these):
     s         session start for the day, v = first touch source
     pv        page view, v = home|collection|product|cart|checkout|other, u = path
     nav       a nav item, v = its path (or text for a menu accordion)
     rail      a category rail tile (home list or the collection page rail), v = the collection handle
     card      a product card, v = the product handle
     dot       a colour dot, v = card|pdp
     sizetab   a size category tab, v = card:youth, toddler, mens...
     size      a size pill, v = card:Small or the PDP option value
     atcclick  a tap on the add to cart button (counts the ones the required radio blocks too)
     atc       the add to cart form submitted
     drawer    the cart drawer opened (by the icon or after an add)
     ladder    a tap on the drawer ladder
     upsell    an upsell add, v = the product handle
     protect   the protection Learn more disclosure (v = info), or the app's switch when visible, v = on|off (real taps only)
     noprot    Checkout without shipping protection
     checkout  the protected checkout button, v = drawer|cart (real taps only)
     eabar     the early access bar, v = topbar|sticky-cta|sticky-mini|sticky-toggle|hero|menu|announcement
     faq       a FAQ question or a FAQ page tab, v = its text
     err       a JS error, v = first 80 chars, scrubbed */
(function () {
  'use strict';
  if (!window.localStorage || !window.JSON) return;
  var S;
  try { S = window.localStorage; } catch (e) { return; }
  var get = function (k) { try { return S.getItem(k); } catch (e) { return null; } };
  var set = function (k, v) { try { S.setItem(k, v); } catch (e) {} };

  if (get('pf_track') === 'off') return;
  if (navigator.globalPrivacyControl === true) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (/[?&]preview_theme_id=/.test(location.search)) return;
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') return;

  var me = document.currentScript;
  var ENDPOINT = (me && me.getAttribute('data-endpoint')) || 'https://pf-sms-proxy.moonless-cro.workers.dev/event';
  var MAX_BATCH = 24, MAX_ERRS = 5, DEBOUNCE = 2500;

  /* --- identity: one id per browser, one start per LA day ------------------------------- */
  function rnd() {
    var a = new Array(16), i;
    if (window.crypto && crypto.getRandomValues) {
      var u = new Uint8Array(8); crypto.getRandomValues(u);
      for (i = 0; i < 8; i++) { a[2 * i] = (u[i] >> 4).toString(16); a[2 * i + 1] = (u[i] & 15).toString(16); }
      return a.join('');
    }
    for (i = 0; i < 16; i++) a[i] = Math.floor(Math.random() * 16).toString(16);
    return a.join('');
  }
  var sid = get('pf_sid'), isNew = false;
  if (!sid || !/^[A-Za-z0-9_-]{8,40}$/.test(sid)) { sid = rnd(); isNew = true; set('pf_sid', sid); }
  function laDay() {
    try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); }
    catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  var seq = parseInt(get('pf_seq') || '0', 10) || 0;

  /* --- the queue ---------------------------------------------------------------------- */
  var q = [], timer = null;
  var pageP = { w: window.innerWidth || 0, t: navigator.maxTouchPoints || 0 };
  function flush() {
    if (timer) { clearTimeout(timer); timer = null; }
    while (q.length) {
      var batch = q.splice(0, MAX_BATCH);
      var body = JSON.stringify({ sid: sid, p: pageP, events: batch });
      var sent = false;
      try { if (navigator.sendBeacon) sent = navigator.sendBeacon(ENDPOINT, body); } catch (e) { sent = false; }
      if (!sent) {
        try { fetch(ENDPOINT, { method: 'POST', body: body, keepalive: true, mode: 'cors', credentials: 'omit', headers: { 'content-type': 'text/plain' } }).catch(function () {}); } catch (e) {}
      }
    }
    set('pf_seq', String(seq));
  }
  function push(n, v, extra, now) {
    var ev = { n: n, i: ++seq };
    if (v != null && v !== '') ev.v = String(v).slice(0, 80);
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) ev[k] = extra[k];
    q.push(ev);
    if (now) { flush(); return; }
    if (!timer) timer = setTimeout(flush, DEBOUNCE);
  }
  window.pfTrack = push;

  /* --- session and page view ---------------------------------------------------------- */
  var clean = function (s, n) { return String(s == null ? '' : s).replace(/\s+/g, ' ').trim().slice(0, n || 80); };
  var pathOf = function (href) { try { return new URL(href, location.href).pathname; } catch (e) { return String(href || '').split('?')[0].slice(0, 80); } };
  var handleOf = function (href, kind) { var m = pathOf(href).match(new RegExp('/' + kind + '/([^/?#]+)')); return m ? m[1] : pathOf(href); };
  function firstTouch() {
    var qs = location.search, src = '', med = '', cmp = '';
    try {
      var sp = new URLSearchParams(qs);
      src = clean(sp.get('utm_source'), 60); med = clean(sp.get('utm_medium'), 40); cmp = clean(sp.get('utm_campaign'), 60);
      if (!src && sp.get('fbclid')) { src = 'facebook'; med = med || 'paid'; }
      if (!src && (sp.get('gclid') || sp.get('gbraid') || sp.get('wbraid'))) { src = 'google'; med = med || 'paid'; }
      if (!src && sp.get('ttclid')) { src = 'tiktok'; med = med || 'paid'; }
    } catch (e) {}
    if (!src) {
      var ref = '';
      try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
      if (ref && ref !== location.hostname) { src = ref.replace(/^www\./, '').replace(/^l\.|^lm\./, ''); med = med || 'referral'; }
    }
    return { src: src || 'direct', med: med, cmp: cmp };
  }
  var today = laDay();
  if (get('pf_td') !== today) {
    var ft = firstTouch();
    push('s', ft.src, { p: { m: ft.med, c: ft.cmp, nr: isNew ? 'n' : 'r' } });
    set('pf_td', today);
  }
  var bc = document.body ? document.body.className : '';
  var ptype = (bc.match(/page-type-([a-z_-]+)/) || [])[1] || '';
  var pv = ptype === 'index' ? 'home' : (ptype === 'collection' || ptype === 'list-collections') ? 'collection' : ptype === 'product' ? 'product' : ptype === 'cart' ? 'cart' : 'other';
  push('pv', pv, { u: clean(location.pathname, 80) });

  /* --- clicks, one delegated listener, the real markup ------------------------------- */
  var closest = function (el, sel) { try { return el.closest ? el.closest(sel) : null; } catch (e) { return null; } };
  /* The protected checkout button and the protection switch are counted on the pointer, not the
     click. The Easy Protection app listens for mousedown and click on window in the capture
     phase and calls stopImmediatePropagation on both before it adds its line and navigates, so
     on a phone the click never reaches this script (2026-10-01: 6 protected orders in an hour,
     one tracked). pointerup fires before the app's mousedown and the app leaves it alone. The
     click branch below stays as the keyboard fallback and skips what the pointer already counted:
     every trusted pointerup counts (two quick flips are two flips), the click that follows one
     within 1.5s does not, a click with no pointer before it (Enter, Space) does. */
  var pointed = function (el) { el.pfPointed = Date.now(); };
  var counted = function (el) { return !!(el.pfPointed && Date.now() - el.pfPointed < 1500); };
  var checkoutTap = function (el) { push('checkout', closest(el, '#offcanvas-cart') ? 'drawer' : 'cart'); push('pv', 'checkout', { u: 'checkout' }, true); };
  var protectTap = function (el, on) { push('protect', on ? 'on' : 'off'); };
  document.addEventListener(window.PointerEvent ? 'pointerup' : 'touchend', function (e) {
    if (!e.isTrusted) return;
    var t = e.target; if (!t || t.nodeType !== 1) t = t && t.parentElement; if (!t) return;
    var el;
    if ((el = closest(t, 'button[name="checkout"]'))) { pointed(el); checkoutTap(el); return; }
    /* the switch flips on the click that follows, so the state it is about to take is the opposite of now */
    if ((el = closest(t, '.easy-switch-input-btn, .easy-switch'))) { var inp = el.matches('input') ? el : el.querySelector('input'); if (inp) { pointed(inp); protectTap(inp, !inp.checked); } return; }
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || t.nodeType !== 1) t = t && t.parentElement; if (!t) return;
    var el, v;
    /* checkout and protection: only real taps. assets/pf-cart-protect.js clicks the switch
       and the checkout button itself, and those must not count as shoppers. */
    if (closest(t, '[data-pf-protect-plain]')) { if (e.isTrusted) { push('noprot'); push('pv', 'checkout', { u: 'checkout' }, true); } return; }
    if ((el = closest(t, 'button[name="checkout"]'))) { if (e.isTrusted && !counted(el)) checkoutTap(el); return; }
    if ((el = closest(t, '.easy-switch-input-btn'))) { if (e.isTrusted && !counted(el)) protectTap(el, el.checked); return; }
    /* the app's own switch card is hidden on this store (pf-cart.css); the shopper's toggle is
       the Learn more disclosure under the protected checkout button */
    if (closest(t, '[data-pf-protect-info]')) { push('protect', 'info'); return; }
    if ((el = closest(t, '.pf-upsell__add, #cart-upsell-list button[name="add"]'))) {
      var slide = closest(el, '.pf-upsell__slide, .product-item, li');
      var a = slide && slide.querySelector('a[href*="/products/"]');
      push('upsell', a ? handleOf(a.getAttribute('href'), 'products') : '');
      return;
    }
    if ((el = closest(t, 'form[action*="/cart/add"] button[name="add"]'))) { push('atcclick', pv === 'product' ? handleOf(location.pathname, 'products') : pathOf(location.pathname)); return; }
    if (closest(t, '#offcanvas-cart .pf-rewards, #cart .pf-rewards')) { push('ladder'); return; }
    /* early access bar, before nav: the menu line and the announcement link are also links */
    if (closest(t, '[data-pf-urgency-topbar]')) { push('eabar', 'topbar'); return; }
    if (closest(t, '.pf-urg__pop-cta')) { push('eabar', 'sticky-cta'); return; }
    if (closest(t, '.pf-urg__pop-mini')) { push('eabar', 'sticky-mini'); return; }
    if (closest(t, '[data-pf-pop-toggle]')) { push('eabar', 'sticky-toggle'); return; }
    if (closest(t, '.pf-urg__cta')) { push('eabar', 'hero'); return; }
    if (closest(t, '.pf-urg--menu')) { push('eabar', 'menu'); return; }
    if (closest(t, '.pf-menu-drop')) { push('eabar', 'menu-drop'); return; }
    if (closest(t, '.pf-menu-offer__btn')) { push('eabar', 'menu-offer'); return; }
    if (closest(t, '.announcement-bar a')) { push('eabar', 'announcement'); return; }
    /* sizes and colours on cards and on the PDP */
    if ((el = closest(t, '.pf-card-sizes__btn[data-pf-group]'))) { push('sizetab', 'card:' + el.getAttribute('data-pf-group')); return; }
    if ((el = closest(t, '.pf-size-tab[data-pf-size-filter]'))) { push('sizetab', el.getAttribute('data-pf-size-filter')); return; }
    if ((el = closest(t, 'a.pf-card-sizes__size'))) { push('size', 'card:' + clean(el.textContent, 20)); return; }
    if (t.matches && t.matches('input.product-option')) {
      /* the label's own click is ignored; the browser sends the input one right after it */
      if (/-option-size-/.test(t.id)) { push('size', clean(t.value, 30)); return; }
      if (/-option-colou?r-/.test(t.id)) { push('dot', 'pdp'); return; }
      return;
    }
    if (closest(t, 'label') && closest(t, '.color-swatches, .product-option-wrapper, [class*="product-option"]')) return;
    if (closest(t, '.product-item .color-swatches button')) { push('dot', 'card'); return; }
    /* FAQ */
    if ((el = closest(t, '.faq .accordion-button, .tabs-with-accordion .tablinks, [data-pfaq-open]'))) { push('faq', clean(el.textContent, 50) || 'open'); return; }
    /* nav: the header icons, the header links, the hamburger */
    if (closest(t, 'a[href="#offcanvas-menu"]')) { push('nav', 'menu'); return; }
    if (closest(t, 'a[href="#offcanvas-search"]')) { push('nav', 'search'); return; }
    if (closest(t, 'a[href="#offcanvas-cart"]')) { push('nav', 'cart'); return; }
    if ((el = closest(t, '.navbar a.nav-link, .navbar a.dropdown-item, .navbar a.navbar-brand, #offcanvas-menu a.nav-link, #offcanvas-menu a.dropdown-item, #offcanvas-menu a.accordion-button, #offcanvas-menu a.btn'))) {
      var h = el.getAttribute('href') || '';
      v = h && h.charAt(0) !== '#' ? pathOf(h) : clean(el.textContent, 30);
      push('nav', v);
      return;
    }
    /* rail tiles and product cards */
    if ((el = closest(t, '.collection-item a[href*="/collections/"], a.pf-rail__link[href*="/collections/"]'))) { push('rail', handleOf(el.getAttribute('href'), 'collections')); return; }
    if ((el = closest(t, '.product-item a[href*="/products/"]'))) { push('card', handleOf(el.getAttribute('href'), 'products')); return; }
  }, true);

  /* add to cart: the form's submit, which only fires once the required radio is ticked */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.getAttribute) return;
    var action = f.getAttribute('action') || '';
    if (action.indexOf('/cart/add') < 0) return;
    if (closest(f, '.pf-upsell__slide, #cart-upsell-list, .cart-upsell')) return;
    push('atc', pv === 'product' ? handleOf(location.pathname, 'products') : pathOf(location.pathname), null, true);
  }, true);

  /* the drawer: Bootstrap's own event bubbles from #offcanvas-cart */
  document.addEventListener('shown.bs.offcanvas', function (e) { if (e.target && e.target.id === 'offcanvas-cart') push('drawer'); }, true);

  /* JS errors: the message only, cut short, addresses and URLs blanked, five per page */
  var errs = 0;
  function scrub(s) { return clean(s, 200).replace(/\S+@\S+/g, '[email]').replace(/https?:\/\/\S+/g, '[url]').slice(0, 80); }
  window.addEventListener('error', function (e) {
    if (errs++ >= MAX_ERRS) return;
    var file = e.filename ? String(e.filename).split('?')[0].split('/').pop() : '';
    push('err', scrub((e.message || 'error') + (file ? ' (' + file + ':' + (e.lineno || 0) + ')' : '')));
  });
  window.addEventListener('unhandledrejection', function (e) {
    if (errs++ >= MAX_ERRS) return;
    var r = e.reason; var m = r && (r.message || (typeof r === 'string' ? r : '')) || 'unhandled rejection';
    push('err', scrub('unhandled: ' + m));
  });

  /* leaving: send what is queued */
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('pagehide', flush);
})();
